module.exports = __webpack_public_path__ + "static/media/snare.80c4129b.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/snare.wav
// module id = 64
// module chunks = 0